let order_MenuItemList = require("../../templates/order/MenuItemList.handlebars");
let $ = require('jquery');
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../../POS.js";
let SubItemView = require("./SubItemView.js");
let {LogUtil} = require('../../utils/utils');
import PackageView from "./PackageView.js";

let main = function () {
    return Backbone.View.extend({
        subItemView: null,
        orderMainHeight: null,
        windowWidth: null,
        orderMainWidth: null,
        packageView: null,
        events: {
            "click .pageUp": "onPrev",
            "click .pageDown": "onNext",
            'click .itemList .menuItem': 'selectItem',
            'click .showCatList .cat': "selectCategory",
            'mousedown .itemList .menuItem, .showCatList .cat': "menuItemTouched",
            'mouseup .itemList': "menuItemUnTouched",
        },

        initialize: function () {
            $(window).on("resize", () => {
                this.orderMainHeight = null;
                this.windowWidth = null;
                this.orderMainWidth = null;
                this.render();
            });
            this.subItemView = new SubItemView({el: $(".orderMain")});
            this.listenTo(this.subItemView, "selectSubItem", this.selectSubItem);
        },

        menuItemTouched: function (evt) {
            var item = $(evt.currentTarget);
            item.addClass('touched');
        },
        menuItemUnTouched: function () {
            $(".itemList .menuItem").removeClass('touched');
        },

        onPrev: function () {
            this.model.prev();
            this.render();
        },

        onNext: function () {
            this.model.next();
            this.render();
        },

        confirmFirst: function () {
            this.$("span.menuitem-wrapper:first").click();
        },
        selectCategory: function (evt) {
            LogUtil.info('MenuItemListView', 'selectCat');
            var catid = $(evt.currentTarget).data("catid");
            var index = $(evt.currentTarget).data("index");
            this.trigger("selectMenuCategory", {catid: catid});
        },
        selectItem: function (evt) {
            const menuItem = $(evt.currentTarget);
            menuItem.addClass('flash');
            var item = menuItem.find('.menuitem-name'), self = this;
            if (item.hasClass('sold-out')) {
                alert('此菜品暂时停售');
                return;
            }

            var itemModel = this.model.get('allCollection').get(item.data("id"));

            if (itemModel.get('subitems') && itemModel.get('subitems').length > 0) {
                console.log('show subitems');
                var subItemList = [];
                _.each(itemModel.get('subitems'), function (item, i) {
                    var sub = self.model.get('allCollection').findWhere({id: item});
                    if (sub) {
                        var params = {};
                        params.name = sub.get("name");
                        params.price = sub.get("price");
                        params.id = sub.get("id");
                        params.catid = sub.get("categoryId");
                        params.symbol = POS.get("restaurantModel").get("currencySymbol");
                        params.soldOut = sub.get("status") == "SoldOut";
                        params.orderIndex = sub.get('orderIndex');
                        subItemList.push(params);
                    }
                });

                subItemList = _.sortBy(subItemList, function (item) {
                    return item.orderIndex;
                });
                this.subItemView.model = subItemList;
                this.subItemView.render();
            } else if (itemModel.get('package')) {
                const container = $("<div id='packageBuilder'></div>");
                $(".orderMain").append(container);
                const packageView = new PackageView({el: container});
                const props = itemModel.attributes;
                props.onConfirm = function (selectedOptions) {
                    console.log("confirming package ", selectedOptions);
                    //const optionAdjustment = _.values(selectedOptions).reduce((sum, option) => sum + option.supplement, 0);
                    this.trigger("selectMenuItem", {
                        menuItemId: item.data("id"),
                        categoryId: item.data("categoryId"),
                        name: item.text(),
                        price: item.data("price"), //+ optionAdjustment,
                        quantity: 1,
                        packageItems: selectedOptions
                    });
                }.bind(this);
                packageView.render(props);

            } else {
                const itemData = {
                    menuItemId: item.data("id"),
                    categoryId: item.data("categoryId"),
                    name: item.text(),
                    price: item.data("price"),
                    quantity: 1
                };

                if (itemModel.get('pricingSchemeItem') && itemModel.get('pricingSchemePrice')) {
                    itemData.pricingSchemePrice = itemModel.get('pricingSchemePrice');
                    itemData.pricingSchemeItem = itemModel.get('pricingSchemeItem');
                }
                this.trigger("selectMenuItem", itemData);
            }
        },
        selectSubItem: function (item) {
            this.trigger("selectMenuItem", {
                menuItemId: item.id,
                categoryId: item.cid,
                name: item.name,
                price: item.price,
                quantity: 1
            });
        },
        render: function () {
            var start = new Date();
            var orderMain = $(".orderMain");
            var self = this;
            if (this.orderMainHeight <= 0) {
                this.orderMainHeight = orderMain.height();
            }
            if (this.windowWidth <= 0) {
                this.windowWidth = $(window).width();
            }
            if (this.orderMainWidth <= 0) {
                this.orderMainWidth = orderMain.width();
            }

            var viewHeight = this.orderMainHeight - 90;
            let screenWidth = this.windowWidth;
            let cellWidth;

            var itemHeight = orderMain.find(".pitem").height();
            var itemWidth = orderMain.find(".pitem").width();
            let itemsInRow = 3;
            if (screenWidth > 768) {
                cellWidth = itemWidth;
                itemsInRow = Math.floor((this.orderMainWidth - 20) / cellWidth);
            } else {
                cellWidth = itemWidth;
                itemsInRow = Math.floor((this.orderMainWidth) / cellWidth);
                viewHeight = this.$(".itemList").height() - 65
            }
            var pageSize = Math.floor(viewHeight / (itemHeight + 6)) * itemsInRow;
            this.model.set({pageSize: pageSize > 0 ? pageSize : 3});

            if (this.model.get("showCat")) {
                if (this.model.get("collection") && this.model.get("collection").length > 0) {
                    this.$el.html(order_MenuItemList({
                        showCat: true,
                        //categories: this.model.getPageCollection().toJSON(),
                        categories: this.model.get('collection').toJSON(),
                        maxPage: this.model.getMaxPage(),
                        currentPage: this.model.get("offset") + 1,
                        disabledNext: !this.model.hasNext(),
                        disabledPrev: !this.model.hasPrev(),
                        showPageInfo: this.model.showPage(),
                        itemSize: this.model.get('collection').length
                    }));
                } else {
                    this.$el.html("");
                }
            } else {
                let menuItems = this.model.getPageCollection().toJSON();
                if (screenWidth > 800) {
                    menuItems = menuItems.map(function (item) {
                        item.aliyunImageUrl = null;
                        return item;
                    });
                }
                if (this.unconfirmedItems) {
                    console.log("hahahaahaha");
                    console.log(this.unconfirmedItems)
                }
                this.$el.html(order_MenuItemList({
                    menuItems: menuItems,
                    maxPage: this.model.getMaxPage(),
                    currentPage: this.model.get("offset") + 1,
                    disabledNext: !this.model.hasNext(),
                    disabledPrev: !this.model.hasPrev(),
                    showPageInfo: this.model.showPage(),
                    itemSize: this.model.get('collection').length,
                    currencySymbol: POS.getRestaurant().get("currencySymbol"),
                    catName: this.model.get("catName")
                }));


                this.$('[data-parentid]').each(function (i, item) {
                    if ($(item).data('parentid') != "") {
                        $(item).parent().parent().addClass('hidden');
                    }
                });

            }

            this.$('.menuItem').first().addClass('fastSelect');
            console.log('menu item view render time', new Date().getTime() - start.getTime());
            return this;
        },
    });

};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/order/MenuItemListView.js